import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";

import { Container, Card, CardContent, Typography } from "@material-ui/core";

import { resetVitrineData } from "redux/reducers/criarVitrineReducer";
import {
  getSessionUserProfiles,
  userIsExclusivelyTipoPessoa,
  TIPO_PESSOA,
} from "utils/profile-classification";

import VitrineWizardShell from "./components/vitrine-wizard-shell";
import { vitrineB2bEditPath } from "./utils/vitrine-b2b-routes";

export default function CriarVitrine() {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const userProfiles = getSessionUserProfiles();
  const isLojista = userIsExclusivelyTipoPessoa(
    userProfiles,
    TIPO_PESSOA.LOJISTA,
  );

  useEffect(() => {
    const legacyEditId = new URLSearchParams(location.search).get("id");
    if (legacyEditId) {
      history.replace(vitrineB2bEditPath(legacyEditId));
      return;
    }

    if (!isLojista) dispatch(resetVitrineData());
  }, [dispatch, history, location.search, isLojista]);

  const legacyEditId = new URLSearchParams(location.search).get("id");
  if (legacyEditId) {
    return null;
  }

  if (isLojista) {
    return (
      <Container maxWidth="md" style={{ marginTop: 32 }}>
        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Acesso não permitido
            </Typography>
            <Typography variant="body1">
              Perfil lojista não tem permissão para criar vitrines.
            </Typography>
          </CardContent>
        </Card>
      </Container>
    );
  }

  return <VitrineWizardShell mode="create" />;
}
